/* rog-topo.js (2026-10-15 per Paul) — the Ride Off Grid topographic map, drawn on canvas.
   Used by sections/rog-col-split-hero.liquid (collection hero + page margins, one continuous map)
   and snippets/rog-footer-topo.liquid (washed-out map behind the footer).
   RogTopo.build(seed, W, H, zoneW, zoneH) -> world   (same seed = same map every visit)
     zone = the top-left area that gets the river, lake + creek and dashed trail (the hero panel).
   RogTopo.paint(canvas, world, y0, width, height, fade, lineFade, dpr)
     paints the world rows y0..y0+height; fade 0..1 washes fills toward paper, lineFade 0..1 lines. */
(function () {
  if (window.RogTopo) return;
  var PAPER = [242, 237, 218], STEP = 0.0175, C = 5;
  function hash(s) { var h = 2166136261; for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619); } return h >>> 0; }
  function rng(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  function makeNoise(r) {
    var N = 256, p = new Float32Array(N * N); for (var i = 0; i < p.length; i++) p[i] = r();
    function v(x, y) { return p[((y & 255) * N) + (x & 255)]; }
    function s(t) { return t * t * (3 - 2 * t); }
    return function (x, y) {
      var xi = Math.floor(x), yi = Math.floor(y), xf = s(x - xi), yf = s(y - yi);
      var a = v(xi, yi), b = v(xi + 1, yi), c = v(xi, yi + 1), d = v(xi + 1, yi + 1);
      return a + (b - a) * xf + (c - a) * yf + (a - b - c + d) * xf * yf;
    };
  }
  function mix(hex, m) { var c = [parseInt(hex.substr(1, 2), 16), parseInt(hex.substr(3, 2), 16), parseInt(hex.substr(5, 2), 16)]; return c.map(function (v, i) { return Math.round(v + (PAPER[i] - v) * m); }); }
  function css(c, a) { return a == null ? 'rgb(' + c[0] + ',' + c[1] + ',' + c[2] + ')' : 'rgba(' + c[0] + ',' + c[1] + ',' + c[2] + ',' + a + ')'; }
  function build(seed, W, Ht, mapW, heroH) {
    var r = rng(hash(seed || 'rog')), n1 = makeNoise(r), n2 = makeNoise(r), n3 = makeNoise(r);
    var ox = r() * 100, oy = r() * 100;
    var gw = Math.ceil(W / C) + 2, gh = Math.ceil(Ht / C) + 2;
    var elev = new Float32Array(gw * gh), veg = new Float32Array(gw * gh);
    function river(y0, amp, len) { var pts = [], a = r() * 6, b = r() * 6, tilt = (r() - .5) * amp * 2; for (var k = 0; k <= 80; k++) { var t = k / 80; pts.push([t * (len + 40) - 20, y0 + Math.sin(t * 5.5 + a) * amp + Math.sin(t * 14 + b) * amp * .28 + tilt * t]); } return pts; }
    function along(pts, x) { var n = pts.length - 1, i = Math.max(0, Math.min(n - 1, Math.floor((x - pts[0][0]) / (pts[n][0] - pts[0][0]) * n))); var a = pts[i], b = pts[i + 1]; return a[1] + (b[1] - a[1]) * ((x - a[0]) / (b[0] - a[0] || 1)); }
    var rivers = [river(heroH * (0.55 + r() * 0.25), heroH * .09, W)];
    if (Ht - heroH > 600) rivers.push(river(heroH + (Ht - heroH) * (0.25 + r() * 0.5), 140, W));
    var mn = 1e9, mx = -1e9;
    for (var j = 0; j < gh; j++) for (var i = 0; i < gw; i++) {
      var x = i * C, y = j * C, sx = (x + ox * 40) / 240, sy = (y + oy * 40) / 240;
      var e = .55 * n1(sx, sy) + .3 * n1(sx * 2.1 + 9, sy * 2.1 + 3) + .15 * n1(sx * 4.3 + 1, sy * 4.3 + 7);
      for (var q = 0; q < rivers.length; q++) { var dy = (y - along(rivers[q], x)) / 92; e -= .16 * Math.exp(-dy * dy); }
      elev[j * gw + i] = e; if (e < mn) mn = e; if (e > mx) mx = e;
      veg[j * gw + i] = .7 * n2(x / 170 + 3, y / 170 + 5) + .3 * n2(x / 70, y / 70);
    }
    function nearRiver(x, y) { for (var q = 0; q < rivers.length; q++) if (Math.abs(y - along(rivers[q], x)) < 10) return true; return false; }
    function lake(cx, cy, rad) { var pts = []; for (var a2 = 0; a2 <= 64; a2++) { var th = a2 / 64 * Math.PI * 2, rr = rad * (1 + .35 * (n3(Math.cos(th) * 1.6 + cx * .01, Math.sin(th) * 1.6 + cy * .01) - .5) * 2 + .12 * Math.sin(th * 5 + 1)); pts.push([cx + Math.cos(th) * rr * 1.5, cy + Math.sin(th) * rr]); } return pts; }
    var lakes = [], lr = Math.min(mapW, heroH) * (.08 + r() * .04), lx = mapW * (.7 + r() * .18), ly = heroH * (.18 + r() * .2);
    lakes.push({ pts: lake(lx, ly, lr), creek: [lx - lr * .6, ly + lr * .7] });
    if (Ht - heroH > 900) { var side = r() < .5 ? W * (.05 + r() * .06) : W * (.89 + r() * .06); lakes.push({ pts: lake(side, heroH + (Ht - heroH) * (.15 + r() * .6), 60 + r() * 30), creek: null }); }
    var trail = [], t0 = heroH * (.25 + r() * .5), tp = r() * 6;
    for (var k3 = 0; k3 <= 60; k3++) { var u = k3 / 60; trail.push([mapW * .04 + u * mapW * .92, t0 + Math.sin(u * 4.5 + tp) * heroH * .12 + Math.sin(u * 15) * 8]); }
    return { gw: gw, gh: gh, elev: elev, veg: veg, mn: mn, mx: mx, rivers: rivers, along: along, nearRiver: nearRiver, lakes: lakes, trail: trail, masks: {} };
  }
  function mask(w, th, col) {
    var key = th + '|' + col.join(','); if (w.masks[key]) return w.masks[key];
    var off = document.createElement('canvas'); off.width = w.gw; off.height = w.gh;
    var oc = off.getContext('2d'), im = oc.createImageData(w.gw, w.gh);
    for (var q = 0; q < w.gw * w.gh; q++) {
      var a = Math.max(0, Math.min(1, (w.veg[q] - th) / .02 + .5));
      if (a > 0 && w.nearRiver((q % w.gw) * C, Math.floor(q / w.gw) * C)) a = 0;
      im.data[q * 4] = col[0]; im.data[q * 4 + 1] = col[1]; im.data[q * 4 + 2] = col[2]; im.data[q * 4 + 3] = a * 255;
    }
    oc.putImageData(im, 0, 0); return (w.masks[key] = off);
  }
  function paint(cv, w, y0, cw, h, m, lf, dpr) {
    m = m || 0; lf = lf || 0; dpr = dpr || 1;
    cv.width = Math.round(cw * dpr); cv.height = Math.round(h * dpr);
    var ctx = cv.getContext('2d'); ctx.setTransform(dpr, 0, 0, dpr, 0, -y0 * dpr);
    ctx.fillStyle = css(PAPER); ctx.fillRect(0, y0, cw, h);
    ctx.imageSmoothingEnabled = true;
    ctx.drawImage(mask(w, .56, mix('#CFE2B0', m)), 0, 0, w.gw * C, w.gh * C);
    ctx.drawImage(mask(w, .67, mix('#B8D497', m)), 0, 0, w.gw * C, w.gh * C);
    var j0 = Math.max(0, Math.floor(y0 / C) - 1), j1 = Math.min(w.gh - 1, Math.ceil((y0 + h) / C) + 1), i1 = Math.min(w.gw - 1, Math.ceil(cw / C) + 1);
    function iso(field, level) {
      ctx.beginPath();
      for (var j = j0; j < j1; j++) for (var i = 0; i < i1; i++) {
        var a = field[j * w.gw + i], b = field[j * w.gw + i + 1], c = field[(j + 1) * w.gw + i + 1], d = field[(j + 1) * w.gw + i];
        var idx = (a > level ? 8 : 0) | (b > level ? 4 : 0) | (c > level ? 2 : 0) | (d > level ? 1 : 0);
        if (idx === 0 || idx === 15) continue;
        var x = i * C, y = j * C;
        var T = [x + C * (level - a) / (b - a), y], R = [x + C, y + C * (level - b) / (c - b)], B = [x + C * (level - d) / (c - d), y + C], L = [x, y + C * (level - a) / (d - a)], s;
        switch (idx) {
          case 1: case 14: s = [L, B]; break; case 2: case 13: s = [B, R]; break; case 3: case 12: s = [L, R]; break;
          case 4: case 11: s = [T, R]; break; case 6: case 9: s = [T, B]; break; case 7: case 8: s = [L, T]; break;
          case 5: s = [L, T, B, R]; break; case 10: s = [L, B, T, R]; break;
        }
        for (var k = 0; k < s.length; k += 2) { ctx.moveTo(s[k][0], s[k][1]); ctx.lineTo(s[k + 1][0], s[k + 1][1]); }
      }
      ctx.stroke();
    }
    var keep = 1 - lf;
    ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    ctx.strokeStyle = css(mix('#7A9C5E', m), keep); ctx.lineWidth = .8; iso(w.veg, .56);
    var l0 = Math.ceil(w.mn / STEP), l1 = Math.floor(w.mx / STEP);
    for (var l = l0; l <= l1; l++) { var major = l % 5 === 0; ctx.strokeStyle = major ? css([150, 120, 80], .9 * keep) : css([181, 154, 114], .75 * keep); ctx.lineWidth = major ? 1.25 : .55; iso(w.elev, l * STEP); }
    ctx.strokeStyle = css([120, 120, 110], .14 * keep); ctx.lineWidth = 1; ctx.beginPath();
    for (var gx = 160; gx < cw; gx += 160) { ctx.moveTo(gx + .5, y0); ctx.lineTo(gx + .5, y0 + h); }
    for (var gy = Math.ceil(y0 / 160) * 160; gy < y0 + h; gy += 160) { if (gy) { ctx.moveTo(0, gy + .5); ctx.lineTo(cw, gy + .5); } }
    ctx.stroke();
    var water = css(mix('#3F95CF', m));
    w.lakes.forEach(function (lk) {
      ctx.beginPath(); lk.pts.forEach(function (p, i) { if (i) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); });
      ctx.closePath(); ctx.fillStyle = css(mix('#9FCDEB', m)); ctx.fill(); ctx.strokeStyle = water; ctx.lineWidth = 1.2; ctx.stroke();
      if (lk.creek) {
        var cx = lk.creek[0], cy = lk.creek[1], ey = w.along(w.rivers[0], cx - 40);
        ctx.beginPath(); ctx.moveTo(cx, cy); for (var c2 = 1; c2 <= 30; c2++) { var tt = c2 / 30; ctx.lineTo(cx - 40 * tt + Math.sin(tt * 9) * 10, cy + (ey - cy) * tt); }
        ctx.strokeStyle = css(mix('#5FA9DB', m)); ctx.lineWidth = 1.5; ctx.stroke();
      }
    });
    w.rivers.forEach(function (rv) {
      ctx.beginPath(); rv.forEach(function (p, i) { if (i) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); });
      ctx.strokeStyle = css(mix('#BFE0F2', m)); ctx.lineWidth = 9; ctx.stroke(); ctx.strokeStyle = water; ctx.lineWidth = 3; ctx.stroke();
    });
    ctx.beginPath(); w.trail.forEach(function (p, i) { if (i) ctx.lineTo(p[0], p[1]); else ctx.moveTo(p[0], p[1]); });
    ctx.setLineDash([6, 5]); ctx.strokeStyle = css(mix('#C2512F', m)); ctx.lineWidth = 1.5; ctx.stroke(); ctx.setLineDash([]);
  }
  window.RogTopo = { build: build, paint: paint };
  document.dispatchEvent(new Event('rogtopo:ready'));
})();
